import type { Chunk, SessionDetail } from "@backstory/protocol";

/**
 * `.backstorysession` is a JSON archive `{ version, session, chunks }` that the Player
 * web component and the fidelity suite can load offline.
 */
export interface BackstorySessionFile {
  version: 1;
  exportedAt: string;
  session: SessionDetail;
  chunks: Chunk[];
}

export async function buildBackstorySession(session: SessionDetail, fetchChunk: (seq: number) => Promise<Chunk>, onProgress?: (done: number, total: number) => void): Promise<BackstorySessionFile> {
  const chunks: Chunk[] = [];
  const refs = [...session.chunks].sort((a, b) => a.seq - b.seq);
  for (let i = 0; i < refs.length; i++) {
    chunks.push(await fetchChunk(refs[i]!.seq));
    onProgress?.(i + 1, refs.length);
  }
  return { version: 1, exportedAt: new Date().toISOString(), session, chunks };
}

export function downloadJson(filename: string, data: unknown): void {
  const blob = new Blob([JSON.stringify(data)], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
